import ReactDOM from 'react-dom'; // ✅ React 17 style
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));